<template>
  <el-container class="ht100">
    <aside-bar :style="subNavDynamicStyle" :routeData="routeData"></aside-bar>
    <!-- 导航栏收缩小按钮 -->
    <div
      class="icon-sub-shrink"
      :style="iconDynamicStyle"
      @click="clickIconSubShrink()"
    >
      <svg class="icon" aria-hidden="true" :style="iconRotateDynamicStyle">
        <use xlink:href="#iconretract-arrow" />
      </svg>
    </div>
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import AsideBar from './components/aside/AsideBar'
export default {
  name: 'User',
  components: {
    AsideBar
  },
  computed: {},
  data() {
    return {
      routeData: [],
      // 导航栏收缩涉及的动态样式
      shrinkSubNav: true,
      subNavDynamicStyle: {
        width: '170px',
        height: '100%',
        display: 'block',
        background: '#f7f8fa',
        'border-right': '1px solid #e1e3e6'
      },
      iconDynamicStyle: { left: '149px' },
      iconRotateDynamicStyle: { transform: 'rotate(0deg)' }
    }
  },
  methods: {
    // 收缩或展开侧边导航栏
    clickIconSubShrink() {
      if (this.shrinkSubNav) {
        this.subNavDynamicStyle = { display: 'none' }
        this.iconDynamicStyle = { left: '0px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(180deg)' }
        this.shrinkSubNav = false
      } else {
        this.subNavDynamicStyle = {
          width: '170px',
          height: '100%',
          display: 'block',
          background: '#f7f8fa',
          'border-right': '1px solid #e1e3e6'
        }
        this.iconDynamicStyle = { left: '149px' }
        this.iconRotateDynamicStyle = { transform: 'rotate(0deg)' }
        this.shrinkSubNav = true
      }
    }
  },
  mounted() {
    // 获取子菜单权限
    this.routeData = this.$authUtis.getModuleMenu('/user')
    this.routeData.filter(item => item.show !== 'false')
  }
}
</script>
<style scoped>
.title {
  position: relative;
  height: 70px;
  line-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
}
.el-row {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 100%;
}
.el-container>.el-main {
  overflow: hidden;
}
</style>
